package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.SubheadlineTextStyle
import club.srams.website.components.layouts.PageLayoutData
import club.srams.website.components.widgets.Carousel
import club.srams.website.toSitePalette
import com.varabyte.kobweb.compose.css.AlignContent
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@InitRoute
fun initTailgateSwapPage_v2(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Tailgate Swap v2"))
}

@Page("/tailgate-swap-v2")
@Layout(".components.layouts.PageLayout")
@Composable
fun TailgateSwapPage_v2() {
    // — Title —
    Row {
        SpanText(
            "Annual Tailgate Swap",
            modifier = Modifier
                .fillMaxWidth()
                .fontSize(3.cssRem)
                .lineHeight(1.2)
                .textAlign(TextAlign.Center)
                .color(
                    when (ColorMode.current) {
                        ColorMode.LIGHT -> Colors.Black
                        ColorMode.DARK -> Colors.White
                    }
                )
        )
    }

    // — Poster image —
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .alignContent(AlignContent.Center),
        horizontalArrangement = Arrangement.Center
    ) {
        Image(
            src = "/images/tailgate/2026_tailgate_poster.jpg",
            alt = "SRAMS poster",
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(700.px)
                .margin {
                    bottom(24.px)
                    top(24.px)
                }
        )
    }

    Row(modifier = Modifier
        .fillMaxWidth()
        .padding { topBottom(2.cssRem) }
        .borderTop(
            1.px
            , LineStyle.Solid
            , ColorMode.current.toPalette().border
        )
        .borderBottom(
            1.px
            , LineStyle.Solid
            , ColorMode.current.toPalette().border
        )
        , horizontalArrangement = Arrangement.Center

    ) {
        Link(
            path = "/tailgate-vendor"
            , text = "Vendor Information"
        )
    }

    carouselSection()
}

@Composable
fun carouselSection() {

    // — 2025 section: 1 col on mobile, 2 cols on MD+ —
    SimpleGrid(
        numColumns = numColumns(base = 1, md = 2),
        modifier = HeroContainerStyle.toModifier()
            .fillMaxWidth()
            .gap(2.cssRem)
    ) {
        // Left: heading
        Box {
            Column(Modifier.gap(2.cssRem)) {
                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText(
                        "2025 Tailgate Swap",
                        Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

        // Right: carousel
        Div {
            Column {
                Carousel(
                    `2025_tailgate_swap`,
                    modifier = Modifier.fillMaxWidth().height(400.px)
                )
            }
        }
    }

}

private val `2025_tailgate_swap` = listOf(
    Pair("/images/tailgate/2025/image_1.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_2.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_3.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_4.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_5.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_6.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_7.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_8.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_9.jpg",  "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_10.jpg", "2025 Annual Tailgate Swap"),
    Pair("/images/tailgate/2025/image_11.jpg", "2025 Annual Tailgate Swap"),
)